import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@shared/index.css";
import Router from "./routes/Router";
import { installGlobalHandlers } from "@shared/util/crashReporter";

installGlobalHandlers();

const root = ReactDOM.createRoot(document.getElementById("root"));

if (import.meta.env.VITE_APP_ENV === "dev") {
  const meta = document.createElement("meta");
  meta.name = "robots";
  meta.content = "noindex, nofollow, noarchive, nosnippet";
  document.head.appendChild(meta);
}

const FALLBACK_API_BASE = `${window.location.origin}/api`;
const EFFECTIVE_API_BASE = import.meta.env.VITE_API_URL || FALLBACK_API_BASE;

axios.interceptors.request.use((config) => {
  if (typeof config.url === "string" && config.url.startsWith("undefined/")) {
    config.url = `${EFFECTIVE_API_BASE}/${config.url.slice("undefined/".length)}`;
  }
  return config;
});

root.render(<Router />);
